import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import { PageTitle } from "../../../_metronic/layout/core";
import { getEInvoiceDetail } from "../generic/crud";
import { showToast, TOAST_FAILURE } from "../../utils/toast/Toast";
import { EInvoicePrintSheet } from "./EInvoicePrintSheet";

/**
 * Printable NIC-format e-Invoice for a sale, fetched live from the server (the IRN, its
 * signed QR and the payload snapshot all live there). Needs the server reachable.
 */
export function EInvoicePrintPage() {
    const { saleId } = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [eInvoice, setEInvoice] = useState(null);

    const breadcrumbs = [
        { title: "Home", path: "/dashboard", isSeparator: false, isActive: false },
        { title: "", path: "", isSeparator: true, isActive: false },
        { title: "Sales List", path: "/sales-list", isSeparator: false, isActive: false },
        { title: "", path: "", isSeparator: true, isActive: false },
    ];

    useEffect(() => {
        if (!saleId) return;
        setIsLoading(true);
        getEInvoiceDetail(saleId)
            .then(({ data }) => {
                setEInvoice(data?.exists ? data.eInvoice : null);
                if (!data?.exists) {
                    showToast(data?.error || "No e-Invoice found for this sale", TOAST_FAILURE);
                }
                setIsLoading(false);
            })
            .catch(() => {
                showToast("Could not load the e-Invoice from the server", TOAST_FAILURE);
                setIsLoading(false);
            });
    }, [saleId]);

    const handleBack = () => navigate("/sales-list");

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>E-Invoice</PageTitle>

            <div className="d-print-none mb-4 d-flex justify-content-between align-items-center">
                <Button variant="outline-secondary" onClick={handleBack}>
                    <i className="bi bi-arrow-left me-2"></i>Back to Sales
                </Button>
                {eInvoice && (
                    <Button variant="primary" onClick={() => window.print()}>
                        <i className="bi bi-printer me-2"></i>Print E-Invoice
                    </Button>
                )}
            </div>

            {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
                    <Spinner animation="border" variant="primary" />
                    <span className="ms-2">Loading e-Invoice…</span>
                </div>
            ) : !eInvoice ? (
                <div className="text-center py-10">
                    <div className="fs-5 fw-bold text-gray-800 mb-1">No E-Invoice Yet</div>
                    <div className="text-muted fs-7 mb-4">
                        This sale has not been registered with the GST portal yet.
                    </div>
                    <Button variant="primary" onClick={handleBack}>Back to Sales</Button>
                </div>
            ) : (
                <EInvoicePrintSheet eInvoice={eInvoice} />
            )}
        </>
    );
}
